module.exports = __webpack_public_path__ + "b3346dffdf8b168e71124b41a5a25d6c.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/body/kite.png
// module id = 1871
// module chunks = 0